export function upperFirst(str: string) {
  return `${str[0].toUpperCase()}${str.substring(1)}`;
}

export function parseString(str: number | string): string {
  return typeof str === 'string' ? str : str.toString();
}

export function parseNumber(str: number | string): number {
  return typeof str === 'string' ? parseInt(str, 10) : str;
}
